// Utils Index - Central export for all utility functions
export const truncateText = (text, maxLength = 25) => {
  if (!text) return "";
  const textStr = String(text);
  return textStr.length > maxLength
    ? `${textStr.substring(0, maxLength)}...`
    : textStr;
};

export const formatAmount = (number) => {
  return "₹" + number.toLocaleString("en-IN");
};

// Re-export all utility modules
export * from "./authentication";
export * from "./clientUtils";
export * from "./currencyUtils";
export * from "./dataUtils";
export * from "./dateUtils";
export * from "./userRole";
export * from "./toast";
